import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ExcelState = {
  activeSheetId: string | null;
};

const initialState: ExcelState = {
  activeSheetId: null,
};

const excelSlice = createSlice({
  name: "excel",
  initialState,
  reducers: {
    setActiveSheetId(state, action: PayloadAction<string | null>) {
      state.activeSheetId = action.payload;
    },
  },
});

export const { setActiveSheetId } = excelSlice.actions;
export default excelSlice.reducer;
